import React from 'react';
import {  StyledAvatar, TextOverflowTooltip } from 'src/common';
import { useStateSelector } from 'src/redux';
import { getProfileCredentials } from 'src/utils/auth';
import { getAvatarColor } from 'src/utils/avatarColor';
import styled from 'styled-components';

const Div = styled.div`
  display: inline-flex;
  align-items: center;
  grid-gap: 8px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;

  span {
    font-weight: 500;
    font-size: 13px;
  }
`;

interface AccessAvatarProps {
  name: string;
  imgUrl?: string | null;
  gradientBlue?: boolean;
  /** Tree nesting level (1-based). Used to determine avatar color. */
  level?: number;
  /** Whether this is a workspace (W) or organisation (O) */
  isWorkspace?: boolean;
}

export const AccessAvatar: React.FC<AccessAvatarProps> = ({ name, imgUrl, gradientBlue, level, isWorkspace }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  const avatarBgColor =
    level !== undefined && isWorkspace !== undefined ? getAvatarColor({ colors, isWorkspace, level }) : undefined;

  const useGradientBlue = !avatarBgColor && (gradientBlue ?? isWorkspace);

  return (
    <Div>
      <StyledAvatar $small $xsmall src={imgUrl || ''} $gradientBlue={useGradientBlue} $bgColor={avatarBgColor}>
        {getProfileCredentials(name)}
      </StyledAvatar>
      <TextOverflowTooltip>
        <span>{name}</span>
      </TextOverflowTooltip>
    </Div>
  );
};
